import React, { useState, useEffect } from "react";
import { postRequest } from "../../services/mainApp.service";
import { History } from "lucide-react";

const PreviousOrders = ({ userData, record }) => {
  const [loading, setLoading] = useState(false);
  const [previousOrders, setPreviousOrders] = useState(null); // will store {Table, Table1}
  const [showPrevOrders, setShowPrevOrders] = useState(false);
  const [expandedOrderId, setExpandedOrderId] = useState(null);

useEffect(() => {

    return () => {
      setPreviousOrders(null);
      setShowPrevOrders(false);
      setExpandedOrderId(null);
    }
}, [])

  const getPreviousOrders = () => {
    if (!record || !record?.OrderMasterId) return;

    setLoading(true);

    postRequest("getOrderDetail", {
      OperationId: 2, // 👈 for previous orders
      CompanyId: userData.CompanyId,
      OrderId: record.OrderMasterId,
      UserId: userData.UserId,
      UserIP: "192.1.1.1",
    })
      .then((response) => {
        setPreviousOrders(response.data.DataSet || { Table: [], Table1: [] });
        setShowPrevOrders(true);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const toggleExpand = (orderId) => {
    setExpandedOrderId(expandedOrderId === orderId ? null : orderId);
  };

  return (
    <div className="mt-4">
      {/* Trigger Button */}
      <div className="flex gap-2 items-center">
      <button
        onClick={getPreviousOrders}
        disabled={loading}
        className="px-4 py-2 flex gap-2 items-center text-sm font-medium text-white bg-indigo-600 rounded-lg  hover:bg-indigo-700 disabled:opacity-50"
      >
       <History className="w-5 h-5 text-white" /> {loading ? "Loading..." : "Show Previous Orders"}
      </button>

      {
        showPrevOrders && (
           
          <button
            onClick={() => setShowPrevOrders(false)}
            className=" px-4 py-2 text-sm text-gray-600 bg-gray-200 rounded hover:bg-gray-300"
          >
            Close
          </button>
        )
      }
</div>
      {/* Orders Section */}
      {showPrevOrders && (
        <div className="mt-4 p-4 border rounded-lg ">
          <h3 className="text-lg font-semibold text-gray-800 mb-3">
            Previous Orders ({previousOrders?.Table?.length || 0})
          </h3>

          {previousOrders?.Table?.length === 0 ? (
            <p className="text-sm text-gray-500">No previous orders found.</p>
          ) : (
            <ul className="space-y-3">
              {previousOrders?.Table?.map((order) => (
                <li
                  key={order.OrderMasterId}
                  className="bg-gray-50  rounded shadow-sm p-4 "
                >
                  {/* Order summary */}
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-sm font-medium text-gray-700">
                        Order #{order.OrderNumber}
                      </p>
                      <p className="text-xs text-gray-500">
                        {order.OrderDate} • <span className="text-black font-semibold text-lg">{order.NetAmount} PKR</span>
                      </p>
                    </div>
                    <button
                      onClick={() => toggleExpand(order.OrderMasterId)}
                      className="text-xs px-3 py-1 rounded bg-indigo-50 text-indigo-600 hover:bg-indigo-200"
                    >
                      {expandedOrderId === order.OrderMasterId
                        ? "Hide Items"
                        : "View Items"}
                    </button>
                  </div>

                  {/* Order Items */}
                  {expandedOrderId === order.OrderMasterId && (
                    <div className="mt-3 border-t pt-3 space-y-2">
                      {previousOrders?.Table1?.filter(
                        (item) => item.OrderMasterId === order.OrderMasterId
                      ).map((item) => (
                        <div
                          key={item.OrderDetailId}
                          className="flex items-center justify-between p-2 bg-gray-50 rounded"
                        >
                          <div className="flex items-center space-x-3">
                            
                            <div>
                              <p className="text-sm font-medium text-gray-700">
                                {item.ProductName}
                              </p>
                              <p className="text-xs text-gray-500">
                                {item.SizeName} • Qty: {item.Quantity}
                              </p>
                            </div>
                          </div>
                          <span className="text-sm font-semibold text-gray-800">
                            {item.PriceWithGST} PKR
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}

       
        </div>
      )}
    </div>
  );
};

export default PreviousOrders;
